module.exports = __webpack_public_path__ + "img/cooperate@2x (1).a1b814b6.png";